// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SubnetSourceTypeSchema = z.enum(['SYSTEM_ROOT','USER_PROVIDED'] as const);

export type SubnetSourceTypeType = `${z.infer<typeof SubnetSourceTypeSchema>}`

export default SubnetSourceTypeSchema;
